import { useEffect, useState } from 'react';
import FadeIn from 'react-fade-in/lib/FadeIn';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { useSelector } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import LoadingComponent from '../../../../lib/LoadingComponent';
import Address from '../../../../lib/Address'; 
import { getBizID, getServices } from '../../../../libs/todoSlice';
import { Card, Input, Button, Table, Empty, Popconfirm } from 'antd';
import Swal from 'sweetalert2';
import { SearchOutlined/* , CloseOutlined */ } from '@ant-design/icons';
import ListIcon from '@mui/icons-material/List';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { Chip, Stack } from '@mui/material';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import SaveIcon from '@mui/icons-material/Save';
import Edit from '@mui/icons-material/Edit';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import CloseIcon from '@mui/icons-material/Close';

const CorporationTable = () => {
    const [loading, setLoading] = useState(false)
    const [doctordata, setDoctorData] = useState([])
    const [countEmployees, setCountEmployees] = useState(0)
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [cookie] = useCookies(['account', 'new_user'])
    const business_id = useSelector(getBizID)
    const [searchtext, setSearchText] = useState('')
    const [defaultdata, setDefaultData] = useState([])
    const [new_user_count, setNew_User_Count] = useState(0)
    const [new_user, setNew_User] = useState()
    const [total, setTotal] = useState()
    const [onlyNewData, setOnlyNewData] = useState(false)
    const [resulttotal, setResultTotal] = useState(0)
    const [data, setData] = useState([]);
    const [positionModal, setPositionModal] = useState({ open: false, data: [], name: '' })
    const [editingKey, setEditingKey] = useState('');
    const isEditing = (record) => record.key === editingKey;
    const services = useSelector(getServices)
    
     
    const customLocale = {
        emptyText: (<Empty description="ไม่มีข้อมูล" />)
    };
     
    const getDoctor = async () => {
        try {
            const { data, status } = await axios({
                method: 'GET',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/v6/businesses/${business_id}/corporation-pre-register/pre-registers`,
                params: {
                    page: page,
                    perPage: pageSize,
                    search: searchtext,
                    onlyNewData: onlyNewData
                }
            })
            setTotal(data.data.total)
            let prepare_data = data.data.result.filter(i => i.status === 'active').map((item, index) => {
                return {
                    index: index + 1,
                    kind: item.kind,
                    _id: item._id,
                    createdAt: item.createdAt,
                    idCardType: item.idCardType,
                    idCardNum: item.idCardNum,
                    employeeID: item.employeeID,
                    email: item.email,
                    mobileNO: item.mobileNO,
                    name_th: (item.specialTitleTH ? item.specialTitleTH : item.accountTitleTH ? item.accountTitleTH : '') + " " +
                        (item.firstNameTH ? item.firstNameTH : '') + " " +
                        (item.middleNameTH ? item.middleNameTH : '') + " " +
                        (item.lastNameTH ? item.lastNameTH : ''),
                    name_eng: (item.specialTitleENG ? item.specialTitleENG : item.accountTitleENG ? item.accountTitleENG : '') + " " +
                        (item.firstNameENG ? item.firstNameENG : '') + " " +
                        (item.middleNameENG ? item.middleNameENG : '') + " " +
                        (item.lastNameENG ? item.lastNameENG : ''),
                    active: item.status,
                    corporation_id: item.employeeID,
                    tel: item.tel ? item.tel : item.other.tel,
                    id_card_type: item.idCardType,
                    cid: item.idCardNum,
                    address_detail: item.other.address_detail,
                    sub_district_th: item.other.sub_district,
                    district_th: item.other.district,
                    province_th: item.other.province,
                    zipcode: item.other.zip_code,
                    birth_date: item.other.birth_date,
                    position: item.position,
                    department: item.other.department,
                    position_list: (() => {
                        try {
                            if (Array.isArray(item.positionList)) {
                                // กรณีเป็น array แต่ข้างในเป็น string
                                if (typeof item.positionList[0] === 'string') {
                                    return JSON.parse(item.positionList[0]);
                                }
                                // กรณีเป็น array object ปกติ
                                return item.positionList;
                            }
                            return [];
                        } catch (e) {
                            return [];
                        }
                    })(),
                    other_tel: item.other.tel,
                }
            })
            setCountEmployees(data.data.total)
            setResultTotal(data.data.resultTotal)
            function isDateBefore24Hours(dateString) {
                const currentDate = new Date();
                const givenDate = new Date(dateString);
                const twentyFourHoursAgo = new Date();
                twentyFourHoursAgo.setHours(currentDate.getHours() - 24);
                return givenDate > twentyFourHoursAgo;
            }
            let newDoctor = prepare_data.filter(item => isDateBefore24Hours(item.createdAt))
            setNew_User(newDoctor)
            setNew_User_Count(data.data.newData)
            setDoctorData(prepare_data)
            setDefaultData(prepare_data)
        }
        catch (err) {
            console.log('err', err)
        }
        setLoading(false)
    }

    useEffect(() => {
        setPage(1)
        setPageSize(10)
    }, [new_user_count])

    useEffect(() => {
        
        getDoctor()
    }, [page, pageSize, onlyNewData])

    useEffect(() => {
        setSearchText('')
        setOnlyNewData(false)
        setLoading(true)
    }, [])

    const columns = [
        {
            title: 'ลำดับ',
            width: 70,
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_, __, index) => {
                return (
                    <>{((page * pageSize) - pageSize) + index + 1}</>
                )
            }
        },
        {
            title: (
                <div>
                    เลขสมาชิก
                </div>
            ),
            dataIndex: 'corporation_id',
            key: 'corporation_id',
            width: 150,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else {
                    return _
                }
            }
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (
                <div>
                    ชื่อ - นามสกุล <br />(ภาษาไทย)
                </div>
            ),
            dataIndex: 'name_th',
            key: 'name_th',
            width: 150,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else {
                    return _
                }
            }
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (
                <div>
                    ชื่อ - นามสกุล <br />(ภาษาอังกฤษ)
                </div>
            ),
            dataIndex: 'name_eng',
            key: 'name_eng',
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else {
                    return _
                }
            }
            // ...getColumnSearchProps('name_eng'),
        },
        {
            title: 'โทรศัพท์',
            dataIndex: 'tel',
            key: 'tel',
            width: 200,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (tel, record, index) => { 
                if (tel === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else if (!record.editTel) { 
                    return (
                        <>
                        {tel} 
                        <IconButton
                            aria-label="edit"
                            size="small"
                            onClick={() => { 
                                setDoctorData(prevData => {
                                    const newData = [...prevData];
                                    newData[record.index - 1] = { ...newData[record.index - 1], editTel: true };
                                    return newData;
                                });

                            }}                          
                        >
                            <Edit fontSize="inherit" />
                        </IconButton>
                    </>
                    )
                    
                } else if (record.editTel){
                    const save = async () => {
                        try {
                            setDoctorData(prevData => {
                                const newData = [...prevData];
                                newData[record.index - 1] = { ...newData[record.index - 1], saveLoading: true };
                                return newData;
                            });
                            const { data } = await axios({
                                method: 'PATCH',
                                url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/pre-register/mobile`,
                                data: {
                                    _id: record._id,
                                    kind: record.kind,
                                    business_id: business_id, 
                                    mobile_no: record.tel
                                }
                            })
                            setDoctorData(prevData => {
                                const newData = [...prevData];
                                newData[record.index - 1] = { ...newData[record.index - 1], editTel: false, saveLoading: false };
                                return newData;
                            });
                            Swal.fire({
                                title: 'เปลี่ยนเบอร์โทรศัพท์สำเร็จ',
                                icon: 'success'
                            })
                        } catch (error) {
                            setDoctorData(defaultdata)
                            Swal.fire({
                                title: 'เปลี่ยนเบอร์โทรศัพท์ไม่สำเร็จ',
                                icon: 'error'
                            })
                        }
                    }
                    return (
                        <>
                            <TextField
                                // value={record.tel}
                                value={record.tel}
                                disabled={record.saveLoading}
                                label="เบอร์โทร"
                                variant="outlined"
                                size="small"
                                onChange={({ target }) => {
                                    if (/^[0-9\b]+$/.test(target.value) || target.value === '') {
                                        setDoctorData(prevData => {
                                            const newData = [...prevData];
                                            newData[record.index - 1] = { ...newData[record.index - 1], tel: target.value.toString().slice(0, 10) };
                                            return newData;
                                        });
                                    }
                                }}
                                sx={{ width: '80%' }}
                            />
                            <IconButton
                                aria-label="edit"
                                size="small"
                                onClick={(e) => {
                                    save()
                                }}
                                disabled={record?.tel?.length < 10}
                                sx={{ width: '20%',top: '7px'}}
                            >
                                <SaveIcon fontSize="inherit" />
                            </IconButton>
                        </>
                    )
                }
            }
        },
        {
            title: 'ประเภทบัตร',
            dataIndex: 'id_card_type',
            key: 'id_card_type',
            width: 180,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_, record, index) => {
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="id_card_type">ประเภทบัตร</InputLabel>
                        <Select
                            value={record.id_card_type}
                            labelId='id_card_type'
                            label="ประเภทบัตร"
                            onChange={(e) => {
                                let tempData = [...data]
                                tempData[record.index - 1].id_card_type = e.target.value
                                setData(tempData)
                            }}
                        >
                            <MenuItem value={'ID_CARD'}>ID_CARD</MenuItem>
                            <MenuItem value={'PASSPORT'}>PASSPORT</MenuItem>
                        </Select>
                    </FormControl>
                ) : (record.id_card_type)
            }
        },
        {
            title: 'เลขประจำตัวประชาชน',
            dataIndex: 'cid',
            key: 'cid',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('cid'),
        },
        {
            title: 'ที่อยู่',
            dataIndex: 'address_detail',
            key: 'address_detail',
            width: 150,
            editable: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            show: true,
            // ...getColumnSearchProps('address'),
        },
        {
            title: 'ตำบล',
            dataIndex: 'sub_district_th',
            width: 150,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            show: true,
            render: (_, record, index) => {
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="sub_district_th">ตำบล</InputLabel>
                        <Select
                            value={record.sub_district_th}
                            labelId='sub_district_th'
                            label="ตำบล"
                            onChange={(e) => {
                                let tempData = [...data]
                                tempData[record.index - 1].sub_district_th = e.target.value
                                setData(tempData)
                            }}
                        >
                            {Address.getSubDistrict(record.province_th, record.sub_district_th).map((sub_district_th, key) => {
                                return <MenuItem key={key} value={sub_district_th}>{sub_district_th}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                ) : (record.sub_district_th)
            }
        },
        {
            title: 'อำเภอ',
            dataIndex: 'district_th',
            width: 150,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            show: true,
            render: (_, record, index) => {
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="district_th">อำเภอ</InputLabel>
                        <Select
                            value={record.district_th}
                            labelId='district_th'
                            label="อำเภอ"
                            onChange={(e) => {
                                let tempData = [...data]
                                tempData[record.index - 1].district_th = e.target.value
                                setData(tempData)
                            }}
                        >
                            {Address.getDistrict(record.province_th).map((district_th, key) => {
                                return <MenuItem key={key} value={district_th}>{district_th}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                ) : (record.district_th)
            }
        },
        {
            title: 'จังหวัด',
            dataIndex: 'province_th',
            width: 150,
            // editable: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            show: true,
            render: (_, record, index) => {
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="province_th">จังหวัด</InputLabel>
                        <Select
                            value={record.province_th}
                            labelId='province_th'
                            label="จังหวัด"
                            onChange={(e) => {
                                let tempData = [...data]
                                tempData[record.index - 1].province_th = e.target.value
                                setData(tempData)
                            }}
                        >
                            {Address.getProvince().map((province_th, key) => {
                                return <MenuItem key={key} value={province_th}>{province_th}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                ) : (record.province_th)
            }
        },
        {
            title: 'รหัสไปรษณีย์',
            dataIndex: 'zipcode',
            key: 'zipcode',
            width: 150,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            show: true,
            render: (_, record, index) => {
                const editable = isEditing(record);
                return editable ? (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="zipcode">รหัสไปรษณีย์</InputLabel>
                        <Select
                            value={record.zipcode}
                            labelId='zipcode'
                            label="รหัสไปรษณีย์"
                            onChange={(e) => {
                                let tempData = [...data]
                                tempData[record.index - 1].zipcode = e.target.value
                                setData(tempData)
                            }}
                        >
                            {Address.getZipCode(record.province, record.district, record.sub_district).map((zipcode, key) => {
                                return <MenuItem key={key} value={zipcode}>{zipcode}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                ) : (record.zipcode)
            }
        },
        {
            title: 'อีเมล',
            dataIndex: 'email',
            key: 'email',
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else {
                    return _
                }
            }

            // ...getColumnSearchProps('name_eng'),
        },
        {
            title: (<div>วันเกิด <br />(ปปปป-ดด-วว)</div>),
            dataIndex: 'birth_date',
            key: 'birth_date',
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else {
                    return _
                }
            }
        },
        {
            title: 'แผนก',
            dataIndex: 'department',
            key: 'department',
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else {
                    return _
                }

            }
            // ...getColumnSearchProps('name_eng'),
        },
        {
            title: 'ตำแหน่ง',
            dataIndex: 'position',
            key: 'position',
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else {
                    return _
                }

            }
            // ...getColumnSearchProps('name_eng'),
        },
        ...(services.includes('position-list') ? [{
            title: 'แผนก/ตำแหน่ง',
            dataIndex: 'position_list',
            key: 'position_list',
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_, record) => (
                <Button
                    variant="text"
                    onClick={() => setPositionModal({
                        open: true,
                        data: Array.isArray(record.position_list) ? record.position_list : [],
                        name: record.name_th
                    })}
                >
                    ดูข้อมูล
                </Button>
            )
        }] : []),
        // {
        //     title: 'เลขบัตรประชาชน',
        //     dataIndex: 'idCardNum',
        //     key: 'idCardNum',
        //     width: 160,
        //     responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        //     render: (_) => {
        //         if (_ === 'WAITING') {
        //             return <LoadingComponent width={50} height={50} />
        //         }
        //         else if (_ !== 'DUMMY') {
        //             return (
        //                 <>{_}</>
        //             )
        //         }
        //         else {
        //             return (
        //                 <>ไม่มีข้อมูล</>
        //             )
        //         }
        //     }
        //     // ...getColumnSearchProps('name_eng'),
        // },
        {
            title: (<div>Status</div>),
            dataIndex: 'active',
            key: 'active',
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_) => {
                if (_ === `WAITING`) {
                    return <LoadingComponent width={50} height={50} />
                } else if (_ === 'active') {
                    return (<Chip label="pre-regis" variant='outlined' color="success" />)
                }
                else {
                    return (<Chip label="revoked" variant='outlined' color="error" />)
                }
            }

            // ...getColumnSearchProps('name_eng'),
        },
        {
            title: 'การจัดการ',
            // dataIndex: 'status',
            width: 100,
            fixed: 'right',
            render: (_, record) => {
                const deleteRecord = async () => {
                    try {
                        const { data, status } = await axios({
                            method: 'DELETE',
                            url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/pre-register/${record._id}?business_id=${business_id}`,
                        })
                        Swal.fire({
                            title: 'ลบข้อมูล Pre register สำเร็จแล้ว',
                            icon: 'success',
                        }).then(({ isConfirmed }) => {
                            setDoctorData(doctordata.filter(e => e._id !== record._id).map((e, index) => {
                                return {
                                    ...e,
                                    index: index + 1,
                                }
                            }))
                            setDefaultData(defaultdata.filter(e => e._id !== record._id).map((e, index) => {
                                return {
                                    ...e,
                                    index: index + 1,
                                }
                            }))
                            setCountEmployees(countEmployees - 1)
                        })
                    } catch ({ response }) {

                    }
                }
                return (
                    <FadeIn>
                        <Stack direction="row" spacing={1}>
                            <>
                                <Popconfirm
                                    title="ต้องการลบข้อมูลนี้ใช่หรือไม่?"
                                    okText="ใช่"
                                    cancelText="ไม่ใช่"
                                    disabled={loading}
                                    onConfirm={() =>
                                        deleteRecord()
                                    }>
                                    <DeleteOutlinedIcon style={{ color: 'red', cursor: "pointer" }} />
                                </Popconfirm>
                            </>
                        </Stack> 
                    </FadeIn>
                )
            }
        },
    ]

    return (
        <FadeIn>
            {
                loading ?
                    <LoadingComponent />
                    :
                    <>
                        <Row>
                            <Col xl={3} lg={4} md={6} sm={12} xs={12}>
                                <Card
                                    style={{
                                        // width: 300,
                                        width: '100%',
                                        borderRadius: '16px',
                                        marginRight: '20px',
                                        marginBottom: '10px',
                                        cursor: 'pointer',
                                        backgroundImage: onlyNewData === false ? 'linear-gradient( transparent -10%, #3776E9 150%)' : 'none',
                                    }}
                                    onMouseOver={({ target }) => {
                                        target.style.transform = `scale(1.1)`
                                        target.style.transition = `all .5s`
                                    }}
                                    onMouseOut={({ target }) => {
                                        target.style.transform = `scale(1.0)`
                                    }}
                                    onClick={() => {
                                        setOnlyNewData(false)
                                        setPage(1)
                                    }}
                                >
                                    <Row>
                                        <Col className='align-self-center' style={{ textAlign: 'center' }}>
                                            <ListIcon style={{
                                                backgroundColor: '#3776E9',
                                                borderRadius: '50%',
                                                fontSize: '52px',
                                                padding: '5px',
                                                color: '#fff',
                                            }} />
                                        </Col>
                                        <Col className='align-self-center' style={{ textAlign: 'center' }}>
                                            <span style={{
                                                fontSize: '31px',
                                                color: '#3776E9',
                                                fontWeight: '700'
                                            }}>
                                                {countEmployees}
                                            </span>
                                            <br />
                                            สมาชิกทั้งหมด
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col xl={3} lg={4} md={6} sm={12} xs={12}>
                                <Card
                                    style={{
                                        width: '100%',
                                        borderRadius: '16px',
                                        cursor: 'pointer',
                                        backgroundImage: onlyNewData === true ? 'linear-gradient( transparent -10%, #053075 160%)' : 'none',
                                    }}
                                    onMouseOver={({ target }) => {
                                        target.style.transform = `scale(1.1)`
                                        target.style.transition = `all .5s`
                                    }}
                                    onMouseOut={({ target }) => {
                                        target.style.transform = `scale(1.0)`
                                    }}
                                    onClick={() => {
                                        setOnlyNewData(true)
                                        setPage(1)
                                    }}
                                >
                                    <Row>
                                        <Col className='align-self-center' style={{ textAlign: 'center' }}>
                                            <PersonAddIcon style={{
                                                backgroundColor: '#EFF4FD',
                                                borderRadius: '50%',
                                                fontSize: '52px',
                                                padding: '5px',
                                                color: '#053075',
                                            }} />
                                        </Col>
                                        <Col className='align-self-center' style={{ textAlign: 'center' }}>
                                            <span style={{
                                                fontSize: '31px',
                                                color: '#3D5D85',
                                                fontWeight: '700'
                                            }}>
                                                {new_user_count}
                                            </span>
                                            <br />
                                            สมาชิกใหม่
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>

                        <div style={{ marginBottom: '20px', marginTop: '20px' }}>
                            <div>
                                <h5>ค้นหา</h5>
                            </div>
                            <div >
                                <Input.Group compact>
                                    <Input
                                        value={searchtext}
                                        allowClear
                                        size="large"
                                        style={{
                                            width: 'calc(50% - 40px)',
                                        }}
                                        placeholder="ค้นหาด้วยชื่อ-นามสกุล, เลขสมาชิก แผนก หรือตำแหน่ง"
                                        onChange={(e) => {
                                            setSearchText(e.target.value);
                                        }}
                                        onPressEnter={() => {
                                            getDoctor()
                                        }}
                                        maxLength={100}
                                    // suffix={
                                    //     // searchParam &&
                                    //     <CloseOutlined
                                    //         onClick={() => {
                                    //             // clearSearch()
                                    //         }}
                                    //         style={{
                                    //             color: 'rgba(0,0,0,.45)',
                                    //         }}
                                    //     />
                                    // }
                                    />
                                    <Button
                                        icon={<SearchOutlined />}
                                        size="large"
                                        style={{ borderRadius: '0px 4px 4px 0px' }}
                                        onClick={() => {
                                            getDoctor()
                                        }}
                                    />
                                </Input.Group>
                            </div>
                        </div>
                        <Table
                            locale={customLocale}
                            columns={columns}
                            // dataSource={doctordata}
                            dataSource={doctordata?.map((item, index) => ({
                                ...item,
                                key: index || item._id,
                            }))}
                            scroll={{
                                x: 1400,
                                y: 400,
                            }}
                            pagination={{
                                page: page,
                                current:page,
                                pageSize: pageSize,
                                onChange: (page, pageSize) => {
                                    setPage(page)
                                    setPageSize(pageSize)
                                },
                                total: resulttotal
                            }}
                        />
                    </>
            }
            <Modal
                open={positionModal.open}
                onClose={() => setPositionModal({ open: false, data: [], name: '' })}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 520,
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 3,
                    maxHeight: '80vh',
                    overflow: 'auto',
                }}>
                    <IconButton
                        onClick={() =>
                            setPositionModal({ open: false, data: [], name: '' })
                        }
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                        }}
                        >
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                        แผนก / ตำแหน่ง
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        {positionModal.name}
                    </Typography>
                    <Divider sx={{ mb: 2 }} />

                    {positionModal.data.length === 0 ? (
                        <Empty description="ไม่มีข้อมูล" />
                    ) : (
                        <Table
                            size="small"
                            pagination={false}
                            dataSource={positionModal.data.map((item, i) => ({ ...item, key: i }))}
                            columns={[
                                {
                                    title: 'แผนก',
                                    dataIndex: 'department',
                                    key: 'department',
                                },
                                {
                                    title: 'ตำแหน่ง',
                                    dataIndex: 'position',
                                    key: 'position',
                                },
                            ]}
                        />
                    )}
                </Box>
            </Modal>
        </FadeIn >

    )
}

export default CorporationTable